import { AbstractOrchestrationFacade } from '../../common';
import { SearchGiftCardMappingsDto } from '../dto';
export class GiftCardCollisionsFacade extends AbstractOrchestrationFacade {
    constructor() {
        super(...arguments);
        this.baseUrl = (merchantId) => `/api/v1/merchants/${encodeURIComponent(merchantId)}/giftcard-collisions`;
    }
    async list(merchantId) {
        const response = await this.client.get(this.baseUrl(merchantId));
        return this.toDto(response, SearchGiftCardMappingsDto);
    }
}
//# sourceMappingURL=GiftCardCollisionsFacade.js.map